<template>
  <div :style="{height: fixedTargetHeight + 'px'}">
    <div class="comp-scroll-fixed" :class="{'fixed': fixed}" :style="{top: top + 'px', zIndex, width: initWidth}" ref="fixedTarget" v-if="$slots.default">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  /*!*
   * @author shaojingchao
   * @date 2019/6/28
   * @project zujuanzaixian
   * @desc 调用v-if chuan
   * @example
   * <tx-scroll-fixed v-if="isLoaded" top="50">
   *    <div class="tab-wrap bb-1px">
   <div class="tab-nav bt-1px">
   </div>
   </div>
   *  </tx-scroll-fixed>
   */
  import {mapState, mapMutations} from 'vuex'
  export default {
    name: 'comp-scroll-fixed',
    props: {
      width: String,
      top: {
        type: [Number, String],
        default: 0
      },
      zIndex: {
        type: Number,
        default: 100
      }
    },
    data () {
      return {
        fixedTargetHeight: 'auto',
        fixed: false,
        distance: 0,
        initWidth: 'auto'
      }
    },
    computed: {
      ...mapState(['scrollTop'])
    },
    watch: {
      scrollTop (v) {
        this.fixed = this.scrollTop >= this.distance
      }
    },
    mounted () {
      let $scroll = $('.comp-scroller')
      $scroll.on('scroll.scrollFixed', () => {
        this.updateScrollTop($scroll.scrollTop())
      })
      this.fixedTargetHeight = this.$refs.fixedTarget.offsetHeight
      this.distance = $(this.$refs.fixedTarget).offset().top - this.top
      this.initWidth = this.width || ($(this.$el).parent().width() + 'px')
    },
    beforeDestroy () {
      $('.comp-scroller').off('scroll.scrollFixed')
    },
    methods: {
      ...mapMutations(['updateScrollTop'])
    }
  }
</script>

<style lang="less">
  .comp-scroll-fixed {
    &.fixed{
      /*width: 100%;*/
      position: fixed;
    }
  }
</style>
